import { setTenant } from "../utils/common";

const commonStore = {
  state: {
    loggedInUser: null,
    isAppInitialized: false,
  },
  reducers: {
    SET_LOGGED_USER: (state, loggedInUser) => {
      if (loggedInUser.tenantId) {
        setTenant(loggedInUser.tenantId);
      }
      return {
        ...state,
        loggedInUser,
      };
    },
    SET_APP_INIT: (state, isAppInitialized) => ({
      ...state,
      isAppInitialized,
    }),
  },
};

export default commonStore;
